/* L'Atelier, October 5, 2026. Loaded by snippets/bfa-style.liquid, deferred.

   THE PRESS LOGOS ON A PHONE: A TAP STOPS THEM, THE NEXT TAP STARTS THEM.

   Block 8 of assets/bfa-atelier-v4.css makes the press logos drift on touch
   screens again. WCAG 2.2.2 needs a way to stop anything that moves on its
   own for more than 5 seconds. sections/bfa-press-reviews.liquid already has
   that control, a pause button clipped out of sight until it takes keyboard
   focus, which a phone cannot reach. So on a screen without hover, a tap on
   the band presses that same button: its own script changes the state, the
   label and aria-pressed, exactly as a keyboard press would.

   The listener sits on the document, so a press section that the theme
   editor re-renders keeps working. A tap on a logo that carries a link still
   follows the link. */
(() => {
  const touch = window.matchMedia('(hover: none)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', event => {
    /* A phone set to reduce motion keeps the still strip (block 8 of the
       stylesheet is skipped there), so there is nothing to pause. */
    if (!touch.matches || still.matches) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('a, button')) return;
    const band = target.closest('.bfa-press [data-bfa-band]');
    if (!band) return;
    const wrap = band.closest('.bfa-press');
    const button = wrap ? wrap.querySelector('[data-bfa-band-toggle]') : null;
    if (button) button.click();
  });
})();
